import script from "./ContactPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactPage.vue?vue&type=script&setup=true&lang=js"

import "./ContactPage.vue?vue&type=style&index=0&id=6ecc982f&lang=scss"

const __exports__ = script;

export default __exports__